/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Practice_MoveInputs */



/**
* | output |
* | --- |
* | "Move {title}" |
*
* @param {Practice_MoveInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_move = /** @type {((inputs: Practice_MoveInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_MoveInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Verplaats ${i?.title}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Déplacer ${i?.title}`)
	return /** @type {LocalizedString} */ (`Move ${i?.title}`)
});